import { render, staticRenderFns } from "./MapUserList.vue?vue&type=template&id=b2877634&scoped=true"
import script from "./MapUserList.vue?vue&type=script&lang=ts"
export * from "./MapUserList.vue?vue&type=script&lang=ts"
import style0 from "./MapUserList.vue?vue&type=style&index=0&id=b2877634&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2877634",
  null
  
)

export default component.exports